import script from "./NavbarLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavbarLinks.vue?vue&type=script&setup=true&lang=ts"

import "./NavbarLinks.vue?vue&type=style&index=0&id=1f7b32d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f7b32d0"]])

export default __exports__